




















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { ModelSync } from 'vue-property-decorator'

@Component({
  components: {
    BaseInput
  }
})
export default class PasswordInput extends Vue {
  @ModelSync('value', 'input') password

  private passwordVisibility: boolean = false

  private get inputType() {
    return this.passwordVisibility ? 'text' : 'password'
  }

  private get btnIcon() {
    return this.passwordVisibility ? 'ion eye-outline' : 'ion eye-off-outline'
  }
}
